export default "__VITE_ASSET__BH7ns1Fm__"